/**
 * @generated SignedSource<<1815f539329d8b4af911a74999f75dea>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type composerPresetConfigurations_list$data = {
  readonly compositionsPaged: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly categories: ReadonlyArray<{
          readonly categoryID: number;
        } | null> | null;
        readonly compositionID: number;
        readonly id: string;
        readonly name: string | null;
        readonly previewImageUrl: string | null;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "composerPresetConfigurations_list";
};
export type composerPresetConfigurations_list$key = {
  readonly " $data"?: composerPresetConfigurations_list$data;
  readonly " $fragmentSpreads": FragmentRefs<"composerPresetConfigurations_list">;
};

import composerPresetConfigurationsPaginationQuery_graphql from './composerPresetConfigurationsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "compositionsPaged"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 60,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "modelID"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": composerPresetConfigurationsPaginationQuery_graphql
    }
  },
  "name": "composerPresetConfigurations_list",
  "selections": [
    {
      "alias": "compositionsPaged",
      "args": [
        {
          "kind": "Literal",
          "name": "draft",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "isTemplate",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "modelID",
          "variableName": "modelID"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": 1
        }
      ],
      "concreteType": "CompositionsPagedConnection",
      "kind": "LinkedField",
      "name": "__composerPresetConfigurations_list_compositionsPaged_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompositionsPagedEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Composition",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "compositionID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "previewImageUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CompositionTemplateCategory",
                  "kind": "LinkedField",
                  "name": "categories",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "categoryID",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "cab7ef477af2ad43f1d8bf85e641607e";

export default node;
